import { render, staticRenderFns } from "./HoverableDropdown.vue?vue&type=template&id=c2fc890e&"
import script from "./HoverableDropdown.vue?vue&type=script&lang=js&"
export * from "./HoverableDropdown.vue?vue&type=script&lang=js&"
import style0 from "./HoverableDropdown.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports